import * as LottiePlayer from "@lottiefiles/lottie-player";
import Logo from "../images/logo_light_grey.png";
import PromptSpin from "../images/prompts.lottie";
import NavButton from "./NavButton";
import GenerateIcon from "../images/icons/nav-icons/nav-icon-generate.svg";
import GenerateIconActive from "../images/icons/nav-icons/nav-icon-generate-active.svg";
import MyCollectionIcon from "../images/icons/nav-icons/nav-icon-my-collection.svg";
import MyCollectionIconActive from "../images/icons/nav-icons/nav-icon-my-collection-active.svg";
import ProfileIcon from "../images/icons/nav-icons/nav-icon-profile.svg";
import ProfileIconActive from "../images/icons/nav-icons/nav-icon-profile-active.svg";
import ExploreIcon from "../images/icons/nav-icons/nav-icon-explore.svg";
import ExploreIconActive from "../images/icons/nav-icons/nav-icon-explore-active.svg";
import SettingsIcon from "../images/icons/nav-icons/nav-icon-settings.svg";
import SettingsIconActive from "../images/icons/nav-icons/nav-icon-settings-active.svg";
import HowToIcon from "../images/icons/nav-icons/nav-icon-how-to.svg";
import HowToIconActive from "../images/icons/nav-icons/nav-icon-how-to-active.svg";
import MarketplaceIcon from "../images/icons/nav-icons/nav-icon-marketplace.svg";
import MarketplaceIconActive from "../images/icons/nav-icons/nav-icon-marketplace-active.svg";
import ChatIcon from "../images/icons/nav-icons/nav-icon-chat.svg";
import ChatIconActive from "../images/icons/nav-icons/nav-icon-chat-active.svg";
import ComfyUIIcon from "../images/icons/nav-icons/nav-icon-comfyui.svg"
import ComfyUIIconActive from "../images/icons/nav-icons/nav-icon-comfyui-active.svg"
import { useDriverContextDispatch } from "../context/DriverContext";
import { useAccountContext, useAccountContextDispatch } from "../context/AccountContext";
import {useGenerateDispatch, useGenerateStatus} from "../context/GenerateContext";
import { useEffect, useState } from "react";
import { usePromptusAPIState } from "../context/PromptusAPIContext";
import { db } from "../db";
import { getCollectionHashes, getCollectionImage, getGenerateOutput, getProgress, getTokens, getUndeliveredImages, setReceived } from "../api-helper";
import { useCollectionContext, useCollectionContextDispatch } from "../context/CollectionContext";
import {useSettingsContext} from "../context/SettingsContext";
import Swal from "sweetalert2";

function Toggles(props){
    return(
        <label className={`relative inline-flex items-center cursor-pointer mr-2 pointer-events-none`} onClick={props.onClick}>
            <span className={`absolute inline-flex h-full w-full rounded-full ${props.checked ? "bg-green-400 animate-ping" : "bg-red-400"} opacity-75`}></span>
            <span className={`relative inline-flex rounded-full h-4 w-4 ${props.checked ? "bg-green-500" : "bg-red-500"}`}></span>
        </label>  
    )
}

export default function NavigationMenu() {
    const generateStatus = useGenerateStatus();
    const driverContextDispatch = useDriverContextDispatch();
    const promptusAPIContext = usePromptusAPIState();
    const accountContextDispatch = useAccountContextDispatch();
    const accountContext = useAccountContext();
    const collectionContext = useCollectionContext();
    const collectionContextDispatch = useCollectionContextDispatch();
    const generateStatusDispatch = useGenerateDispatch();
    const apiState = usePromptusAPIState();
    const [serverCPU, setServerCPU] = useState(false);
    const [serverGPU, setServerGPU] = useState(false);
    const [serverCloud, setServerCloud] = useState(true);
    const [animations, setAnimations] = useState(false);
    const [loading, setLoadingImages] = useState(false);
    const [update, setUpdate] = useState(false);
    const [imageList, setImageList] = useState([]);
    const { showChatButton, setShowChatButton } = useSettingsContext();
    const [undeliveredStatus, setUndeliveredStatus] = useState("");
    const [fetchingUndelivered, setFetchingUndelivered] = useState(false);
    const [pendingWorkload, setPendingWorkload] = useState(false);
    const [pendWorkDetails, setPendWorkDetails] = useState({});
    const [pendWorkProgress, setPendWorkProgress] = useState(0)
    const [startTimer, setStartTimer] = useState(false)
    const [seconds, setSeconds] = useState(0)

    const refreshApp = async() => {
        // sessionStorage.setItem('hasVisited', 'false');
        // sessionStorage.setItem('initialCollectionLoad', 'false');
        const autoRecovery = await db.settings.where('key').equals('auto_recovery').first(setting => {
            return setting.value;
        });        

        const findFailedMatches = (failedImages, undeliveredImages) => {
            console.log("Looking for failed matches to deliver");
            
            return undeliveredImages.filter(largeItem => 
                failedImages.some(smallItem => smallItem.uid === largeItem.jobUid)
            );
          };
    
        const removeFailedMatches = (failedImages, undeliveredImages) => {
            console.log("Removing failed matches from undelivered images");
            
            return undeliveredImages.filter(largeItem => 
                !failedImages.some(smallItem => smallItem.uid === largeItem.jobUid)
            );
        };  
    
        const checkingUndeliveredImages = async () => {
            console.log("Checking if a workload was active");
            if (fetchingUndelivered) return;
        
            setFetchingUndelivered(true);
            console.log("Checking for undelivered images");
            console.log("API State: ", apiState);
        
            const autoRecovery = await db.settings.where('key').equals('auto_recovery').first(setting => {
                return setting.value;
            });
        
            if (apiState.online == true && autoRecovery) {
                console.log("Auto Recovery is enabled, checking for undelivered images");
        
                let moreUndeliveredImages = true; // Flag to indicate if there are more undelivered images to fetch
        
                while (moreUndeliveredImages) {
                    await getUndeliveredImages(accountContext.accountDetails.accountNo).then(async(data) => {
                        console.log("Undelivered Images: ", data);
        
                        // Filter out any empty job UIDs
                        const undeliveredUids = data.filter(uid => uid.jobUid !== "");
                        console.log("Undelivered Images Filtered: ", undeliveredUids);
        
                        // If no new undelivered images are found, stop the loop
                        if (undeliveredUids.length === 0) {
                            console.log("No more undelivered images found, stopping process");
                            moreUndeliveredImages = false;
                            return;
                        }
        
                        generateStatusDispatch({ type: 'undeliveredImages' });
                        generateStatusDispatch({ type: 'totalUndeliveredImages', totalUndeliveredImages: undeliveredUids.length });
        
                        // Handle failed images from the database
                        const undeliveredFailedImages = await db.images.filter(image => image.image === "" && image.online).toArray();
                        const uniqueArray = undeliveredFailedImages.reduce((acc, item) => {
                            if (!acc.some(existingItem => existingItem.uid === item.uid)) {
                                acc.push(item);
                            }
                            return acc;
                        }, []);
                        console.log("Undelivered Failed Images: ", uniqueArray);
        
                        const failedMatches = findFailedMatches(uniqueArray, undeliveredUids);
                        console.log("Found undelivered images: ", failedMatches);
        
                        if (failedMatches.length > 0) {
                            for (const undeliveredFailedImage of failedMatches) {
                                generateStatusDispatch({ type: 'checkingUndeliveredImages' });
                                console.log("Undelivered Image: ", undeliveredFailedImage.uid);
                                const results = await db.images.where('uid').equals(undeliveredFailedImage.jobUid).and(item => item.image === '').toArray();
                                if (results.length > 0) {
                                    console.log("Results: ", results[0]);
                                    console.log("Output UID: ", undeliveredFailedImage.uid);
                                    const hashcheck = await db.images.where('hash').equals(undeliveredFailedImage.uid).first();
                                    const image = await getGenerateOutput(undeliveredFailedImage.jobUid, undeliveredFailedImage.uid);
                                    const imageCheck = await db.images.where('image').equals(image.image).first();
                                    if (!hashcheck && !imageCheck) {
                                        generateStatusDispatch({ type: 'retrievingUndeliveredImages' });
                                        await db.images.update(results[0].id, {
                                            image: image.image,
                                            seed: image.seed,
                                            model: image.model ?? '',
                                            hash: undeliveredFailedImage.uid,
                                            prompt: image.prompt,
                                            receivedtimestamp: Date.now()
                                        });
                                        generateStatusDispatch({ type: 'totalRetrievedImages' });
                                        console.log("Image uid ", undeliveredFailedImage.uid, "returned image: ", image);
                                    }
                                    setReceived(undeliveredFailedImage.jobUid, undeliveredFailedImage.uid);
                                }
                            }
                        }
        
                        const remainingImages = removeFailedMatches(uniqueArray, undeliveredUids);
                        console.log("Remaining Images: ", remainingImages);
        
                        if (remainingImages.length > 0) {
                            console.log("There are undelivered images that are not failed images");
                            if (remainingImages.length > 50) {
                                Swal.fire({
                                    color: "#190A4E",
                                    title: `You have ${remainingImages.length} undelivered images. This is a large amount of image and it might take some time so please be patient.`,
                                    icon: "info",
                                    showConfirmButton: false,
                                    showCancelButton: false,
                                    timer: 2000
                                });
                            }
        
                            await Promise.all(
                                remainingImages.map(async (undeliveredImage) => {
                                    generateStatusDispatch({ type: 'checkingUndeliveredImages' });
                                    console.log("Undelivered Image: ", undeliveredImage.uid);
                                    const hashcheck = await db.images.where('hash').equals(undeliveredImage.uid).first();
                                    const image = await getGenerateOutput(undeliveredImage.jobUid, undeliveredImage.uid);
                                    const imageCheck = await db.images.where('image').equals(image.image).first();
                                    if (!hashcheck && !imageCheck) {
                                        generateStatusDispatch({ type: 'retrievingUndeliveredImages' });
                                        await db.images.put({
                                            image: image.image,
                                            seed: image.seed,
                                            uid: undeliveredImage.jobUid,
                                            model: image.model ?? '',
                                            inCollection: false,
                                            hash: undeliveredImage.uid,
                                            online: apiState.online,
                                            tag: "",
                                            prompt: image.prompt,
                                            receivedtimestamp: Date.now(),
                                            requestedtimestamp: Date.now()
                                        });
                                        generateStatusDispatch({ type: 'totalRetrievedImages' });
                                        console.log("Image uid ", undeliveredImage.uid, "returned image: ", image);
                                    }
                                    setReceived(undeliveredImage.jobUid, undeliveredImage.uid);
                                })
                            );
                        }
                    });
                    console.log("END OF THE WHILE LOOP");
                    console.log("Cancel Check: ", generateStatus.cancellingUndeliveredCheck);
                    
                    if (generateStatus.cancellingUndeliveredCheck == true) {
                        console.log("Cancelling the while loop");
                        generateStatusDispatch({ type: 'resetcancellingUndeliveredCheck' })
                        break;
                    }
                }
            }
            generateStatusDispatch({ type: 'done' });
            setFetchingUndelivered(false);
        };
        
        if (!autoRecovery) {
            await checkingUndeliveredImages().finally(() => {
                document.location.reload();
            })
        } else {
            document.location.reload();
        }
    }

    let populating = false;
    const populateCollection = async (accountNo) => {
        if (populating) {
            console.log("Collection Busy Populating");
            return;
        }
    
        populating = true;
        console.log("Populating collection with images from the server");
        let hashArray = await getCollectionHashes(accountNo);
        collectionContextDispatch({type: 'totalImages', payload: hashArray.length});

        console.log("Hash Array: ", hashArray);
            // Use map to create an array of promises
            await Promise.all(
                hashArray.map(async(hash, index) => {
                    console.log("INSIDE THE PROMISE");
                    const image = await getCollectionImage(accountNo, hash.hash)
                    const hashcheck = await db.collectedImages.where('hash').equals(image.hash).first();
                    if (!hashcheck) {
                        await db.collectedImages.put({uid: image.uid, imageID: index + 1, image: image.image, seed: image.seed, model: image.model, hash: image.hash, online: image.online, tag: image.tag, prompt: image.prompt, public: image.public});
                        console.log("Loaded image from the server: ", image.imageID, image.hash);
                    }
                })
            ).catch(error => {
                console.error("An error occurred while loading images: ", error);
            }).finally(() => {
                console.log("THE FINALLY SECTION");
                
                sessionStorage.setItem('finishedCollectionLoad', 'true');
                collectionContextDispatch({type: 'finishedLoading'});
                populating = false
                //setLogloading(false);
            });
            // const imagePromises = hashArray.map((hash, index) => {
            //     return getCollectionImage(accountNo, hash.hash)
            //         .then(image => {
            //             // Create an object that includes both the image and its original index
            //             return { image, index };
            //         });
            // });

            // // Wait for all promises to resolve
            // Promise.all(imagePromises).then(images => {
            //     images.forEach(({ image, index }) => {
            //         // Now you can use the index if needed to maintain original order
            //         const hashcheck = db.collectedImages.where('hash').equals(image.hash).first();
            //         if (!hashcheck) {
            //             db.collectedImages.put({uid: image.uid, imageID: index + 1, image: image.image, seed: image.seed, model: image.model, hash: image.hash, online: image.online, tag: image.tag, prompt: image.prompt, public: image.public});
            //             console.log("Loaded image from the server: ", image.imageID, image.hash);
            //         }
            //     });
            //     console.log("Finished loading images from the server");
            //     // collectionContextDispatch({type: 'finishedLoading'});
            // }).catch(error => {
            //     console.error("An error occurred while loading images: ", error);
            // }).finally(() => {
            //     sessionStorage.setItem('finishedCollectionLoad', 'true');
            //     collectionContextDispatch({type: 'finishedLoading'});
            //     populating = false
            //     //setLogloading(false);
            // });

    }

    useEffect(() => {
        if (localStorage.getItem('account')) {
            let accountDetails;
            try {
                accountDetails = JSON.parse(localStorage.getItem('account'));
            } catch (error) {
                console.error("Error grabbing account from local storage: ", error);
            }

            let passSecret;
            try {
                passSecret = JSON.parse(localStorage.getItem("password"));
            } catch (error) {
                console.error("Error grabbing pass from local storage: ", error);
            }
            console.log("Account details: ", accountDetails);
            accountContextDispatch({type: 'login', signin: accountDetails, passSecret: passSecret})
            accountContextDispatch({type: 'tokens', tokens: accountDetails.tokens})
            if ((!sessionStorage.getItem('initialCollectionLoad') || sessionStorage.getItem('initialCollectionLoad') === "false") && db.collectedImages.count() === 0){
                console.log("Initial collection load");
                sessionStorage.setItem('initialCollectionLoad', 'true');
                db.collectedImages.clear();
                populateCollection(accountDetails.accountNo);
            } else {
                sessionStorage.setItem('initialCollectionLoad', 'true');
                sessionStorage.setItem('finishedCollectionLoad', 'true');
                collectionContextDispatch({type: 'finishedLoading'});
            }


            if (sessionStorage.getItem('initialCollectionLoad') || sessionStorage.getItem('initialCollectionLoad') === "true") {
                sessionStorage.setItem('finishedCollectionLoad', 'true');
                collectionContextDispatch({type: 'finishedLoading'});
            }
            if (sessionStorage.getItem('finishedCollectionLoad')) {
                collectionContextDispatch({type: 'finishedLoading'});
            }

            try {
                getTokens(accountDetails.accountNo).then(data => {
                    accountContextDispatch({type : "tokens", tokens: data.credits})
                })
            } catch (error) {
                console.error("Error fetching tokens for user: ", error)
                accountContextDispatch({type : "tokens", tokens: 0})
            }
        }
        
    },[])
    
    useEffect(() => {        
        const workloadDetails = JSON.parse(localStorage.getItem("remember_workload"))
        setPendWorkDetails(workloadDetails)
        if (workloadDetails.active && apiState.host !== "" && apiState.host.includes("api") && !pendingWorkload) {
            setPendingWorkload(true)
            console.log("Starting Pending Workload");
            setTimeout(() => fetchPendingJob(workloadDetails.uid), 2500);
        }
    }, [apiState.host])

    useEffect(() => {
        if (!startTimer) return;
    
        const timer = setInterval(() => {
          setSeconds(prevSeconds => prevSeconds + 1);
        }, 1000);
    
        console.log("Seconds: ", seconds);

        if (seconds === 90) {
          clearInterval(timer);
          console.log("A minute and a half has passed, timing out the pending job");
           if (pendWorkDetails.uid) {
                // generateStatusDispatch({ type: 'error', message: "Job Timed Out" });
                setPendingWorkload(false)
                setPendWorkDetails({})
                setPendWorkProgress(0)
                localStorage.setItem('remember_workload', JSON.stringify({
                    active: false,
                    uid: "",
                    count: 0,
                    totalImage: 0,
                    num: 0,
                }))
                setStartTimer(false);
                setSeconds(0);
            }
        }
    
        return () => clearInterval(timer);
      }, [startTimer, seconds]);

    let num = 0;
    let jobProgression = 0;
    const fetchPendingJob = async (uuid) => {
        setPendingWorkload(true)
        setStartTimer(true);
        let uid = "";
        let progress = 0;    
        // if (!uid) {
        //     if (pendWorkDetails.uid) {
        //     }
        // }
        uid = uuid;
    
        let playSounds;
        await db.settings.where('key').equals('play_sounds').first(setting => {
            playSounds = setting.value;
        });
        const workloadDetails = JSON.parse(localStorage.getItem("remember_workload"))
    
        console.log("Fetching pending job data for: ", uid, " with the apiState: ", apiState);
        if (uid) {
            await getProgress(uid, apiState, generateStatusDispatch)
            .then(async(data) => {
                console.log("Pending Workload Progress Data: ", data);
                setPendWorkProgress(Number(data.progress))

                if (jobProgression !== data.progress) {
                    jobProgression = data.progress;
                    setSeconds(0);
                }

                progress = Number(data.progress);
                if (data && data.output && Array.isArray(data.output)) {
                    await Promise.all(
                        data.output.map(async(item) => {
                            const outputUid = item.uid;
                            console.log("Image id from getProgress", outputUid);
    
                            if (outputUid) {
                                try {
                                    const hashcheck = await db.images.where('hash').equals(outputUid).first();
                                    if (!hashcheck) {
                                        const image = await getGenerateOutput(uid, outputUid);
                                        console.log("IMAGE", image);
    
                                        if (image) {
                                                await db.images.put({
                                                    image: image.image,
                                                    seed: image.seed,
                                                    uid: uid,
                                                    model: image.model ?? '',
                                                    inCollection: false,
                                                    hash: outputUid,
                                                    online: apiState.online,
                                                    tag: generateStatus.tag,
                                                    prompt: image.prompt,
                                                    receivedtimestamp: Date.now(),
                                                    requestedtimestamp: Date.now()
                                                })
                                                .then(() => {
                                                    setReceived(uid, outputUid);
                                                    num += 1;
                                                    // refreshImages();
                                                    generateStatusDispatch({
                                                        type: 'imageProgress',
                                                        setting: playSounds
                                                    });
                                                })
                                                .catch(e => {
                                                    console.error('Error while adding images:', e);
                                                    console.error('Error stack trace:', e.stack);
                                                    console.error("Inner Exception: ", e.inner);
                                                    console.error('Error message:', e.message);
                                                    if (e.name !== "ConstraintError") {
                                                        console.error(e);
                                                        generateStatusDispatch({
                                                            type: 'error',
                                                            message: `An error occurred adding images. ${e.name}`
                                                        });
                                                    }
                                                    if (e.name === "ConstraintError") {
                                                        console.error(e);
                                                        generateStatusDispatch({
                                                            type: 'error',
                                                            message: `An error occurred adding images. ${e.name}`
                                                        });
                                                    }
                                                    generateStatusDispatch({
                                                        type: 'error',
                                                        message: `An error occurred adding images. ${e.name}`
                                                    });
                                                    // doCancelJob();
                                                    setStartTimer(false);
                                                    setSeconds(0);
                                                })
                                        }
                                    }
                                } catch (error) {
                                    console.error("Error in processing:", error);
                                    setStartTimer(false);
                                    setSeconds(0);
                                }
                            }

                        })
                    )
                }

                if (data.progress == 100) {
                    console.log("Pending Workload Completed");
                    setPendingWorkload(false)
                    localStorage.setItem('remember_workload', JSON.stringify({
                        active: false,
                        uid: "",
                        count: 0,
                        totalImage: 0,
                        num: 0,
                    }))
                    setStartTimer(false);
                    setSeconds(0);
                    window.location.reload();
                }
            })
            .catch((error) => {
                console.error('Pending :- Error occurred fetching the generation progress:', error);
                console.error('Pending :- Error stack trace:', error.stack);
                console.error("Pending :- Inner Exception: ", error.inner);
                console.error('Pending :- Error message:', error.message);
                setStartTimer(false);
                setSeconds(0);
            })
            // try {
            // } catch (error) {
            // }
        }

        console.log("BEFORE :=- PW: ", pendingWorkload, " | WD: ", workloadDetails.active, " | P: ", progress);
    
        // This part ensures the function reschedules itself regardless of errors or if uid is not present
        if (workloadDetails.active || progress < 100) {
            console.log("PW: ", pendingWorkload, " | WD: ", workloadDetails.active, " | P: ", progress);
            
            setTimeout(() => fetchPendingJob(uuid), 2500);
        }
    }
    

    useEffect(() => {
        if (promptusAPIContext.activeCPU) {
            setServerCPU(true)
            setServerGPU(false);
            setServerCloud(false)
        }

        if (promptusAPIContext.activeGPU) {
            setServerGPU(true)
            setServerCPU(false);
            setServerCloud(false)
        }
        
        if (promptusAPIContext.online) {
            setServerCPU(false);
            setServerGPU(false);
        }
        setServerCloud(promptusAPIContext.online);
    }, [promptusAPIContext.online, promptusAPIContext.activeGPU, promptusAPIContext.activeCPU])

    useEffect(() => {
        db.settings.where("key").equals("enable_animations").first(setting => {
            setAnimations(setting.value)
        })
    }, [generateStatus.loading])


    let fetching = false;
    const rebuildImages = async (accountNo) => {
        if (fetching){
            console.log("Fetching collection is already in progress");
            return;
        }
        
        // setFetchingCollection(true);
        fetching = true;
        console.log("Starting collection rebuild process");
        
        // Check if a toggle operation is in progress
        const toggleLock = await db.settings.get('toggleLock');
        if (toggleLock && toggleLock.value === true) {
            console.log("Toggle operation in progress, skipping rebuild");
            return;
        }
    
        // Fetch hashes from the API
        const apiHashes = await getCollectionHashes(accountNo);
        if (!apiHashes) {
            console.error("Failed to fetch API hashes");
            return;
        }
    
        // Get local hashes from the database
        const localHashes = await db.collectedImages.toArray(images => images.map(img => img.hash));
    
        const hashesToAdd = apiHashes.filter(apiHash => !localHashes.includes(apiHash.hash));
        // const hashesToRemove = localHashes.filter(localHash => !apiHashes.some(apiHash => apiHash.hash === localHash));
    
        let changed = false;
    
        // Remove images not present in API
        // for (const hashToRemove of hashesToRemove) {
        //     changed = true;
        //     console.log(`Removing image with hash ${hashToRemove} from local collection`);
        //     await db.collectedImages.where('hash').equals(hashToRemove).delete();
            
        //     const imagesToUpdate = await db.images.where('hash').equals(hashToRemove).toArray();
        //     for (const image of imagesToUpdate) {
        //         await db.images.update(image.id, { inCollection: false });
        //     }
        // }

        // Add images from API not present locally
        for (const hashToAdd of hashesToAdd) {
            changed = true;
            console.log(`Adding image with hash ${hashToAdd.hash} to local collection`);
            const image = await getCollectionImage(accountNo, hashToAdd.hash);
            if (image) {
                const iCount = await db.collectedImages.count() + 1;
                const hashcheck = await db.collectedImages.where('hash').equals(image.hash).first();
                if (!hashcheck) {
                    await db.collectedImages.put({
                        uid: image.uid,
                        imageID: iCount,
                        image: image.image,
                        seed: image.seed,
                        model: image.model,
                        hash: image.hash,
                        online: image.online,
                        tag: image.tag,
                        prompt: image.prompt,
                        public: false
                    });
                    await db.images.where('hash').equals(hashToAdd.hash).modify({ inCollection: true });
                } else {
                    console.log("Image with hash ", hashToAdd.hash, " already exists in the local collection");
                }
    
            }
        }
    
        if (changed) {
            console.log("Changes detected, triggering reload");
            await db.reloadImages.put({ reload: "1" });
            await db.reloadImages.put({ reload: "2" });
        }
    
        console.log("Rebuild process completed");
        // setFetchingCollection(false);
        fetching = false;
    };


    const POLLING_INTERVAL = 10000; // Poll every 10 seconds

    useEffect(() => {
        let interval;
        if (sessionStorage.getItem('finishedCollectionLoad') || collectionContext.finishedLoading == true) {
            interval = setInterval(async () => {
                    const collectionCount = await db.collectedImages.count();
                    const accountDetails = await db.account.where("key").equals("accountDetails").first();
                    if (accountDetails && accountDetails.value && accountDetails.value.accountNo) {
                        if (collectionCount > 0) {
                            console.log("POLLING FOR CHANGES");
                            try {
                                await rebuildImages(accountDetails.value.accountNo);
                                collectionContextDispatch({type: 'finishedLoading'});
                            } catch (error) {
                                console.error("An error occurred during the rebuild process:", error);
                            }
                        } else if (collectionCount === 0) {
                            console.log("No images in the collection, Populating collection");
                            populateCollection(accountDetails.value.accountNo);
                        }
                    }
            }, POLLING_INTERVAL);
        }

        return () => clearInterval(interval);
    }, [db,update,collectionContext.finishedLoading]); // Adjust dependencies based on actual variables that affect the effect


    useEffect(() => {
        const fetchChatSetting = async () => {
            const setting = await db.settings.get({ key: 'use_aihorde_models' });
            setShowChatButton(setting ? setting.value === true : false);
        };

        fetchChatSetting();
    }, []);

    useEffect(() => {
        if (generateStatus.undeliveredImages) {
            if (generateStatus.checkingUndeliveredImages) {
                setUndeliveredStatus("Undelivered images found!");
            } else if (generateStatus.retrievingUndeliveredImages) {
                setUndeliveredStatus("Retrieving undelivered images...");
            } else {
                setUndeliveredStatus("Checking for undelivered images...");
            }   
        }
    }, [generateStatus.undeliveredImages, generateStatus.checkingUndeliveredImages, generateStatus.retrievingUndeliveredImages]);

    useEffect(() => {
        const updatePrompts = async () => {
            await db.open();

            if (db.isOpen()) {
                console.log("Database is open");
                
            }
            db.transaction('rw', db.images, db.collection, async () => {        
                console.log("Updating prompts in the local DB");      
                await db.images.orderBy('id').each(async image => {                    
                    if (!image.prompt || image.prompt == '') {
                        console.log("Prompt is empty, updating prompt for image: ", image.id);
                        const promptHistory = async () => await db.collection.where('uid').equals(image.uid).first();            
                        promptHistory().then(async (data) => {                
                            console.log("Updating prompt for image: ", image.id, " with prompt: ", data.prompt.prompt.prompt);
                            await db.images.update(image.id, {prompt: data.prompt.prompt.prompt})
                        });
                    }
                });
              }).then(() => {
                console.log('Prompts have been successfully added.');
              }).catch(err => {
                console.error('Failed to update timestamps:', err);
              });
        }

        const updateTimestamps = async() => {
            await db.open();
            if (db.isOpen()) {
                console.log("Database is open");
            }
            // Assume a time gap between records, e.g., 1 second
            const timeGap = 1000; // 1 second in milliseconds
            const totalNumberOfRecords = await db.images.count();
            
            // Start with an initial timestamp, such as the current time minus the total time span
            const initialTimestamp = Date.now() - (timeGap * (totalNumberOfRecords - 1));

            db.transaction('rw', db.images, async () => {
            let currentTimestamp = initialTimestamp;

            await db.images.orderBy('id').each(async image => {
                if (!image.receivedtimestamp || !image.requestedtimestamp) {
                    console.log("Timestamps are empty, updating timestamps for image: ", image.id);                    
                    console.log("Updating timestamps for image: ", image.id, " with timestamp: ", currentTimestamp);
                    await db.images.update(image.id, { receivedtimestamp: currentTimestamp, requestedtimestamp: currentTimestamp });
                    currentTimestamp += timeGap;
                }
            });
            }).then(() => {
                console.log('Timestamps have been successfully added.');
            }).catch(err => {
                console.error('Failed to update timestamps:', err);
            });
        }

        const updateSHtoAI = async() => {
            await db.open();
            if (db.isOpen()) {
                console.log("Database is open");
            }

            db.transaction('rw', db.images, async () => {
            await db.images.orderBy('id').each(async image => {
                if (image.model.includes('SH')) {
                    let newModel = image.model.replace('SH', 'AI-Horde');
                    console.log("Model includes SH, updating model for image: ", image.id, image.model, newModel);
                    await db.images.update(image.id, { model: newModel });
                }
            });
            }).then(() => {
                console.log('Conversion from SH to AI Horde have been successfully completed.');
            }).catch(err => {
                console.error('Failed to update SH:', err);
            });
        }

        updateSHtoAI();
        updatePrompts();
        updateTimestamps();
    },[]);

    const cancelPendingWorkload = () => {
        console.log("Cancelling pending workload");
        setPendingWorkload(false)
        setPendWorkDetails({})
        setPendWorkProgress(0)
        localStorage.setItem('remember_workload', JSON.stringify({
            active: false,
            uid: "",
            count: 0,
            totalImage: 0,
            num: 0,
        }))
    }

    return (
        <aside className="relative md:sticky top-0 px-5 2xl:px-10 flex flex-col gap-4 items-center bg-dark-purple/20 backdrop-blur-sm w-full md:w-1/6 text-white max-h-screen min-w-min overflow-y-auto overflow-x-hidden">
            <div className={`flex flex-col items-center mt-2 lg:pb-10 ${generateStatus.loading ? 'animate-pulse' : ''}`}>
                <div className={`w-24 lg:w-8/12 cursor-pointer`} onClick={refreshApp}>
                    {generateStatus.loading ? 
                        <>
                            {animations ?
                                <lottie-player
                                autoplay
                                loop
                                mode="normal"
                                src={PromptSpin}
                                ></lottie-player>
                            :
                                 <img src={Logo} alt={"Promptus Logo"} />  
                            }
                        </>

                    :
                        <img src={Logo} alt={"Promptus Logo"} />
                    }
                </div>
                <h1 className={"text-lg lg:text-5xl font-bold"}>Promptus</h1>
            </div>
            {(generateStatus.loading || generateStatus.undeliveredImages) ?
                <div className={"transition flex flex-col items-center w-full"}>
                    <div className={"flex flex-row justify-between w-full text-sm"}>
                        {generateStatus.undeliveredImages ? 
                            <span className={"font-medium"}>{undeliveredStatus}</span>
                        : 
                            <>
                                <span className={"font-medium"}>Generated {generateStatus.count ? `${generateStatus.totalImages} of ${generateStatus.count}` : ''}</span>
                                <span className={"font-medium"}>{`${(Number(generateStatus.progress) >= 0) ? Math.ceil(Number(generateStatus.progress)) : 0}%`}</span>
                            </>
                        }
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                        {generateStatus.undeliveredImages ?
                            <div className="bg-green-500 h-2.5 rounded-full animate-pulse" style={{width: `100%`}}></div>    
                        :
                            <div className="bg-yellow h-2.5 rounded-full animate-pulse" style={{width: `${Number(generateStatus.progress)}%`}}></div>
                        }
                    </div>
                    {generateStatus.undeliveredImages ?
                        <>
                            <div className={"flex flex-col w-full text-sm mt-2"}>
                                <div className="flex flex-row">
                                    <span className={"font-medium"}>Retrieved</span>
                                    <span className={"ms-1 font-medium"}>{generateStatus.totalRetrievedImages} out of {generateStatus.totalUndeliveredImages} images</span>
                                </div>
                                <button className={`rounded-lg bg-red-800 py-1 px-2 shadow-xl font-bold text-base w-1/2 mt-2 ml-auto`} onClick={() => generateStatusDispatch({ type: 'cancellingUndeliveredCheck' })}>Cancel</button>
                            </div>
                        </>  
                    :
                        <>
                            <div className={"flex flex-col w-full text-sm mt-2"}>
                                <span className={"font-medium"}>Job UID:</span>
                                <span className={"font-medium"}>{generateStatus.uid}</span>
                            </div>
                        </>    
                    }
                </div>
                : null}
            {pendingWorkload ?
                <>
                    <div className="h-1 border border-white w-full"></div>
                    <div className={"transition flex flex-col items-center w-full"}>
                        <div className={"flex flex-row justify-between w-full text-sm"}>
                                    <span className={"font-medium"}>Pending Workload</span>
                                    <span className={"font-medium"}>{`${(Number(pendWorkProgress) >= 0) ? Math.ceil(Number(pendWorkProgress)) : 0}%`}</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                                <div className="bg-red-600 h-2.5 rounded-full animate-pulse" style={{width: `${Number(pendWorkProgress)}%`}}></div>    
                                {/* <div className="bg-yellow h-2.5 rounded-full animate-pulse" style={{width: `${Number(generateStatus.progress)}%`}}></div> */}
                        </div>
                            <div className={"flex flex-col justify-start w-full text-sm mt-2"}>
                                <span className={"font-medium"}>Job UID:</span>
                                <span className={"font-medium"}>{pendWorkDetails.uid}</span>
                                <button className={`rounded-lg bg-red-800 py-1 px-2 shadow-xl font-bold text-base w-1/2 mt-2 ml-auto`} onClick={cancelPendingWorkload}>Cancel</button>
                            </div>
                    </div> 
                    <div className="h-1 border border-white w-full"></div>   
                </>
            :
                null    
            }    
            <div className={"flex flex-col w-full gap-4 items-center mt-10"}>
                <NavButton icon={GenerateIcon} activeIcon={GenerateIconActive} label={"Playground"} to={"/"} onClick={() => {
                    setUpdate(!update);
                    driverContextDispatch({type: 'reset'})
                    }}/>
                <NavButton icon={MyCollectionIcon} activeIcon={MyCollectionIconActive} label={"My Collection"} to={"/my-collection"} onClick={() => setUpdate(!update)}/>
                <NavButton icon={ProfileIcon} activeIcon={ProfileIconActive} label={`${accountContext.loggedIn ? 'Profile' : 'Login'}`} to={"/profile"} onClick={() => setUpdate(!update)}/>
                <NavButton icon={ExploreIcon} activeIcon={ExploreIconActive} label={"Explore"} to={"/explore"} onClick={() => setUpdate(!update)}/>
                <NavButton icon={SettingsIcon} activeIcon={SettingsIconActive} label={"Settings"} to={"/settings"} onClick={() => setUpdate(!update)}/>
                <NavButton icon={HowToIcon} activeIcon={HowToIconActive} label={"Help"} to={"/how-to"} onClick={() => setUpdate(!update)}/>
                {showChatButton  && (
                    <NavButton
                        icon={ChatIcon}
                        activeIcon={ChatIconActive}
                        label={"Chat"}
                        to={"/chat"}
                        onClick={() => setUpdate(!update)}
                    />
                )}
                <NavButton icon={ComfyUIIcon} activeIcon={ComfyUIIconActive} label={"Comfy UI"} to={"/comfyui"} onClick={() => setUpdate(!update)}/>
                <NavButton icon={MarketplaceIcon} activeIcon={MarketplaceIconActive} label={"Marketplace"} to={"/marketplace"} extraStyle={"h-20"} smallImage={"w-9"} onClick={() => setUpdate(!update)}/>
                <div className={"text-xs place"}>v{process.env.REACT_APP_VERSION}</div>
            </div>
                <div className="justify-self-end flex flex-row gap-3 md:flex-col md:gap-0">
                    <div className={"bg-dark-blue/30 flex col-span-2 flex-row rounded-xl place-content-center place-items-center gap-2 p-2 max-h-min"}>
                        <Toggles onClick={() => setServerCPU(!serverCPU)} checked={serverCPU} />
                        <span className={`font-bold text-lg xl:whitespace-nowrap ${serverCPU ? 'text-yellow' : 'text-gray-400'} transition`}>CPU Server</span>
                    </div>
                    <div className={"bg-dark-blue/30 flex col-span-2 flex-row rounded-xl place-content-center place-items-center gap-2 p-2 max-h-min"}>
                        <Toggles onClick={() => setServerGPU(!serverGPU)} checked={serverGPU} />
                        <span className={`font-bold text-lg xl:whitespace-nowrap ${serverGPU ? 'text-yellow' : 'text-gray-400'} transition`}>GPU Server</span>
                    </div>
                    <div className={"bg-dark-blue/30 flex col-span-2 flex-row rounded-xl place-content-center place-items-center gap-2 p-2 max-h-min ps-5"}>
                        <Toggles onClick={() => setServerCloud(!serverCloud)} checked={serverCloud} />
                        <span className={`font-bold text-lg xl:whitespace-nowrap ${serverCloud ? 'text-yellow' : 'text-gray-400'} transition`}>Cloud Server</span>
                    </div>
                </div>
        </aside>
    );
};
